/**
 * Inherit Model allows inheritance of models. Right now, there is code
 * performing a spread operator on an uncalled function, which doesn't do
 * anything.
 *
 * The below function is not type-safe at the moment. We'll need to improve the
 * types of this and ValidateJS.
 */
export const inheritModel = (
  model: any,
  value: unknown,
  attributes: unknown,
  attributeName: unknown,
  options: unknown
) => {
  if (typeof model === 'function') {
    const results = model(value, attributes, attributeName, options);

    if (typeof results !== 'boolean') {
      return results;
    }
  }
  return model;
};
